import {
  useMutation,
  useQueryClient,
} from '@tanstack/react-query'
import api from '../../services/api';
import { getIsActiveFromFormData } from '../../utils/parseIsActive';


export const useIndustryStore = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (body) => {
      const isFormData = body instanceof FormData;

      const config = isFormData
        ? { headers: { "Content-Type": "multipart/form-data" } }
        : {};

      const res = await api.post("/industry/create", body, config);
      return res;
    },
    onSuccess: (res, variables) => {
      const submittedActive = getIsActiveFromFormData(variables);
      const createdRaw =
        res?.data?.data?.industry ||
        res?.data?.data ||
        res?.data?.industry ||
        res?.data;

      const created =
        createdRaw && (createdRaw._id || createdRaw.id)
          ? {
              ...createdRaw,
              ...(submittedActive !== undefined && {
                isActive: submittedActive,
                status: submittedActive ? "Active" : "Inactive",
              }),
            }
          : createdRaw;

      if (created && (created._id || created.id)) {
        queryClient.setQueryData(["viewIndustry"], (old) => {
          // old is whatever `useViewIndustryQuery` returns (res.data)
          const oldList =
            old?.data?.industry ||
            old?.data ||
            old?.industry ||
            old ||
            [];

          if (!Array.isArray(oldList)) return old;

          const createdId = created._id || created.id;
          const exists = oldList.some((x) => (x?._id || x?.id) === createdId);
          const nextList = exists ? oldList : [created, ...oldList];

          if (old && typeof old === "object" && !Array.isArray(old)) {
            if (Array.isArray(old.data)) return { ...old, data: nextList };
            if (old.data && typeof old.data === "object" && Array.isArray(old.data.industry)) {
              return { ...old, data: { ...old.data, industry: nextList } };
            }
            if (Array.isArray(old.industry)) return { ...old, industry: nextList };
            return { ...old, data: nextList };
          }

          return nextList;
        });
      }

      queryClient.invalidateQueries({ queryKey: ["viewIndustry"] });
    },
    onError: (error) => {
      console.error("Create industry failed:", error);
    },
  });

};